import { Col,  Row, Tree,Flex,Radio,} from 'antd';
import React, { useEffect, useMemo, useState, useCallback } from 'react'
import { FolderOutlined, FolderOpenOutlined } from '@ant-design/icons';
import BackendList from '../backend/BackendList';
import ModuleDropdown from '../module/ModuleDropdown';
import { useTaskManageUpdateQuery } from '../../store/BnsKeJiApi';
import SubModuleDropdown from '../submodule/SubModuleDropdown';
import InterfaceDropdown from './InterfaceDropdown';
import InterfaceDesc from './InterfaceDesc';
function InterfaceInfo(props) {
    // 处理树形数据，添加自定义图标
    const processTreeData = useCallback((data, parentPath = '') => {
        return data?.map((item, index) => {
            // 确保key的唯一性，使用父路径和当前索引
            const uniqueKey = item.value ? String(item.value) : `${parentPath}-${index}`;
            return {
                ...item,
                key: uniqueKey,
                icon: item.children && item.children.length > 0 ? 
                    <FolderOpenOutlined style={{ color: '#1890ff' }} /> : 
                    <FolderOutlined style={{ color: '#1890ff' }} />,
                children: item.children ? processTreeData(item.children, uniqueKey) : undefined
            };
        }) || [];
    }, []);

    const processedTreeData = useMemo(() => processTreeData(props.children), [props.children, processTreeData]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [selectedNodeInfo, setSelectedNodeInfo] = useState(null);

    // 递归查找节点路径 - 使用useCallback优化
    const findNodePath = useCallback((treeData, targetKey, path = []) => {
        for (let i = 0; i < treeData.length; i++) {
            const node = treeData[i];
            const currentPath = [...path, {
                value: node.value,
                label: node.title,
                key: node.key
            }];
            
            if (node.key === targetKey) {
                return currentPath;
            }
            
            if (node.children && node.children.length > 0) {
                const found = findNodePath(node.children, targetKey, currentPath);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }, []);

    // 从本地存储恢复选中的树节点
    useEffect(() => {
        const savedSelectedKey = localStorage.getItem('interfaceInfo_selectedKey');
        const savedNodeInfo = localStorage.getItem('interfaceInfo_nodeInfo');
        const savedPanel = localStorage.getItem('interfaceInfo_panel');
        
        // 恢复panel状态
        if (savedPanel) {
            setPanel(savedPanel);
        }
        
        if (savedSelectedKey && processedTreeData.length > 0) {
            // 验证保存的key是否在当前树数据中存在
            const findNodeByKey = (treeData, targetKey) => {
                for (let i = 0; i < treeData.length; i++) {
                    const node = treeData[i];
                    if (node.key === targetKey) {
                        return node;
                    }
                    if (node.children && node.children.length > 0) {
                        const found = findNodeByKey(node.children, targetKey);
                        if (found) return found;
                    }
                }
                return null;
            };
            
            const node = findNodeByKey(processedTreeData, savedSelectedKey);
            if (node) {
                setSelectedKeys([savedSelectedKey]);
                
                // 恢复节点信息
                if (savedNodeInfo) {
                    try {
                        const parsedNodeInfo = JSON.parse(savedNodeInfo);
                        setSelectedNodeInfo(parsedNodeInfo);
                    } catch (e) {
                        console.error('解析保存的节点信息失败:', e);
                    }
                } else {
                    // 如果没有保存的节点信息，重新构建节点信息
                    const nodePath = findNodePath(processedTreeData, savedSelectedKey);
                    if (nodePath) {
                        const nodeInfo = {
                            current: {
                                value: node.value,
                                label: node.title,
                                key: node.key
                            },
                            path: nodePath,
                            allValues: nodePath.map(node => node.value),
                            allLabels: nodePath.map(node => node.label)
                        };
                        setSelectedNodeInfo(nodeInfo);
                    }
                }
            }
        }
        
        // 重置info状态到初始值
        setInfo({
            et_content: '',
            et_e_id: localStorage.getItem('e_id'),
            et_name: '',
            et_update_uid: localStorage.getItem('eu_id'),
            et_update_uname: localStorage.getItem('eu_name'),
            etu_user_id: '',
            etu_user_name: '',
            et_date:'',
            et_id:props.et_id,
            et_grade:'1',
            et_status:'1',
        });
        
        // 如果没有保存的选中状态，重置panel到默认值
        if (!savedSelectedKey) {
            setPanel('2');
        }
    }, [props.children, props.et_id, processedTreeData, findNodePath]);

    // 处理树节点选择事件
    const onSelect = (selectedKeys, info) => {        
        setSelectedKeys(selectedKeys);
        
        // 获取选中节点及其所有上级节点的value和label
        if (info.selected && info.node) {
            const nodePath = findNodePath(processedTreeData, info.node.key);
            
            if (nodePath) {
                const nodeInfo = {
                    current: {
                        value: info.node.value,
                        label: info.node.title,
                        key: info.node.key
                    },
                    path: nodePath, // 包含当前节点和所有上级节点的完整路径
                    allValues: nodePath.map(node => node.value), // 所有上级节点的value数组
                    allLabels: nodePath.map(node => node.label)  // 所有上级节点的label数组
                };
                setSelectedNodeInfo(nodeInfo);
                
                // 保存选中的节点信息到本地存储
                localStorage.setItem('interfaceInfo_selectedKey', info.node.key);
                localStorage.setItem('interfaceInfo_nodeInfo', JSON.stringify(nodeInfo));
                
                console.log('选中的节点信息:', nodeInfo);
                console.log('节点路径:', nodePath);
            }
        } else {
            // 如果没有选中节点，清除本地存储
            localStorage.removeItem('interfaceInfo_selectedKey');
            localStorage.removeItem('interfaceInfo_nodeInfo');
            setSelectedNodeInfo(null);
        }
    };

    // 根据路径组装 BackendList 所需的字段
    const backendListParams = useMemo(() => {
        const path = selectedNodeInfo?.path || [];
        const lvl1 = path[0];
        const lvl2 = path[1];
        const lvl3 = path[2];
        return {
            bgn_id: lvl1?.value,
            bgn_name: lvl1?.label,
            bbb_id: lvl2?.value,
            bbb_name: lvl2?.label,
            et_id: lvl3?.value,
            et_name: lvl3?.label,
        };
    }, [selectedNodeInfo]);
    const isThirdLevelSelected = useMemo(() => {
        const pathLength = selectedNodeInfo?.path?.length || 0;
        return pathLength === 3;
    }, [selectedNodeInfo]);
    //切换任务和接口详情
    const [panel,setPanel] = useState('2')
    //接口详情
    const [info,setInfo] = useState({
        et_content: '',
        et_e_id: localStorage.getItem('e_id'),
        et_name: '',
        et_update_uid: localStorage.getItem('eu_id'),
        et_update_uname: localStorage.getItem('eu_name'),
        etu_user_id: '',
        etu_user_name: '',
        et_date:'',
        et_id:props.et_id,
        et_grade:'1',
        et_status:'1',
    });
    const {data,isSuccess} = useTaskManageUpdateQuery(
        { et_id: isThirdLevelSelected ? backendListParams.et_id : undefined },
        { skip: !isThirdLevelSelected }
    )
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data,'1111');
                let etu_user_id;
                etu_user_id = data.Result.user.map((item) => {
                    return item.etu_user_id
                })
                let etu_user_name;
                etu_user_name = data.Result.user.map((item) => {
                    return item.etu_user_name
                })
                setInfo(prevState=>({...prevState,
                    et_date:data.Result.et_date,
                    et_status:data.Result.et_status,
                    et_content:data.Result.et_content,
                    et_name:data.Result.et_name, 
                    etu_user_id:etu_user_id,    
                    etu_user_name:etu_user_name,  
                    et_grade:data.Result.et_grade,                            
                    et_bg_id:data.Result.et_bg_id,            
                    et_bg_name:data.Result.et_bg_name,         
                    et_bgn_id:data.Result.et_bgn_id,            
                    et_bgn_name:data.Result.et_bgn_name,            
                    et_bbb_id:data.Result.et_bbb_id,            
                    et_bbb_name:data.Result.et_bbb_name, 
                
                    et_id:data.Result.et_id,                                 
                    et_uid:data.Result.et_uid, 
                    et_e_id:data.Result.et_e_id,                                
                }))
            }
        }
    },[data,isSuccess])
    return (
        <Row style={{padding:"20px",background:"#fff"}}>
            <Col span={6} style={{borderRight:"1px solid #ccc"}}>
                <Tree
                    showIcon={false}
                    defaultExpandAll
                    selectedKeys={selectedKeys}
                    onSelect={onSelect}
                    treeData={processedTreeData}
                    titleRender={(node) => {
                        
                        const isSelected = selectedKeys.includes(node.key);
                        
                        // 获取当前节点的路径信息
                        const nodePath = findNodePath(processedTreeData, node.key);
                        const nodeLevel = nodePath ? nodePath.length : 0;
                        
                        // 根据节点层级渲染不同的编辑组件
                        const renderEditComponent = () => {
                            if (!isSelected || !nodePath) return null;
                            
                            const path = nodePath;
                            const lvl1 = path[0];
                            const lvl2 = path[1];
                            const lvl3 = path[2];
                            
                            switch (nodeLevel) {
                                case 1: // 第一级 - 模块
                                    return  <ModuleDropdown 
                                                bg_id={props.bg_id}
                                                bg_name={props.bg_name}
                                                bg_dept_id={props.bg_dept_id}
                                                bg_dept_name={props.bg_dept_name}
                                                bgn_id={lvl1?.value}                                                     
                                                bgn_name={lvl1?.label} 
                                            />;
                                case 2: // 第二级 - 子模块
                                    return <SubModuleDropdown 
                                        bg_id={props.bg_id}
                                        bg_name={props.bg_name}
                                        bgn_id={lvl1?.value}
                                        bgn_name={lvl1?.label}
                                        bbb_id={lvl2?.value}
                                        bbb_name={lvl2?.label}
                                    />;
                                case 3: // 第三级 - 接口
                                    return <InterfaceDropdown 
                                                bg_id={props.bg_id}
                                                bg_name={props.bg_name}
                                                bgn_id={lvl1?.value}
                                                bgn_name={lvl1?.label}
                                                bbb_id={lvl2?.value}
                                                bbb_name={lvl2?.label}
                                                et_id={lvl3?.value}
                                                et_name={lvl3?.label}
                                                et_uid={info.et_uid}
                                                et_e_id={info.et_e_id}
                                                et_content={info.et_content}
                                                et_update_uid={info.et_update_uid}
                                                et_update_uname={info.et_update_uname}
                                                etu_user_id={info.etu_user_id}
                                                etu_user_name={info.etu_user_name}
                                                et_date={info.et_date}
                                                et_status={info.et_status}
                                                et_grade={info.et_grade}
                                                et_bg_id={info.et_bg_id}
                                                et_bg_name={info.et_bg_name}
                                                et_bgn_id={info.et_bgn_id}
                                                et_bgn_name={info.et_bgn_name}
                                                et_bbb_id={info.et_bbb_id}
                                                et_bbb_name={info.et_bbb_name}
                                                eu_id={props.eu_id}
                                                eu_name={props.eu_name}
                                            />;
                                default:
                                    return null;
                            }
                        };
                        
                        return (
                            <Flex justify='space-between' align='center' style={{ width: '100%' }}>
                                <span style={{ display:'flex', alignItems:'center', gap:'6px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                                    {node.icon}
                                    <span>{node.title}</span>
                                    {/* 根据最后一级节点的 et_grade 显示 1-5 个火焰图标 */}
                                    {(() => {
                                        const grade = Math.max(0, Math.min(5, Number(node.et_grade || 0)));
                                        const isLeaf = !node.children || node.children.length === 0;
                                        if (!isLeaf || grade === 0) return null;
                                        const labels = {
                                            1: '（低）',
                                            2: '（低）',
                                            3: '（中）',
                                            4: '（高）',
                                            5: '（高）',
                                        };
                                        const label = labels[grade];
                                        return (
                                            <span style={{ fontSize: 14 ,color:'#ff4d4f'}}>{label}</span>
                                        );
                                    })()}
                                </span>
                                <div onClick={(e) => e.stopPropagation()}>
                                    {renderEditComponent()}
                                </div>
                            </Flex>
                        );
                    }}
                    blockNode 
                />
            </Col>
            <Col span={18} style={{paddingLeft:"10px"}}>
                <Flex justify='space-between'>
                    <Radio.Group
                        buttonStyle='solid'
                        optionType="button" 
                        value={panel}
                        onChange={(e) => {
                            setPanel(e.target.value);
                            // 保存panel状态到本地存储
                            localStorage.setItem('interfaceInfo_panel', e.target.value);
                        }}
                    >
                        <Radio value='1'>接口详情</Radio>                    
                        <Radio value='2'>任务</Radio>
                    </Radio.Group>                    
                </Flex>
                {(panel==='1' && isThirdLevelSelected) && <InterfaceDesc 
                                                                et_id={backendListParams.et_id} 
                                                                et_name={backendListParams.et_name}
                                                                et_content={backendListParams.et_content}
                                                                eu_id={props.eu_id}
                                                                eu_name={props.eu_name}
                                                        />}
                {(panel==='2' && isThirdLevelSelected) && <BackendList 
                    bg_id={props.bg_id}
                    bg_name={props.bg_name}
                    bgn_id={backendListParams.bgn_id}
                    bgn_name={backendListParams.bgn_name}
                    bbb_id={backendListParams.bbb_id}
                    bbb_name={backendListParams.bbb_name}
                    et_id={backendListParams.et_id}
                    et_name={backendListParams.et_name}
                    nodeInfo={selectedNodeInfo}
                    et_uid={info.et_uid}
                />}
            </Col>
            
        </Row>
    )
}

export default InterfaceInfo